'use client';

import { ReactElement, ReactNode } from 'react';

import { Popover } from 'react-tiny-popover';

import { useBreakpoint } from '@contexts/breakpoints';

import { PACKAGE_TEMPLATE_POPOVER_Z_INDEX } from './constants';
import PackageTemplateMobileModal from './PackageTemplateMobileModal';

interface PackageTemplateResponsiveDropdownProps {
  isOpen: boolean;
  title: string;
  trigger: ReactElement;
  onClose: () => void;
  renderContent: (options: { mobile: boolean; width?: number }) => ReactNode;
}

const PackageTemplateResponsiveDropdown = ({
  isOpen,
  title,
  trigger,
  onClose,
  renderContent,
}: PackageTemplateResponsiveDropdownProps) => {
  const { xs: isMobile } = useBreakpoint();

  if (isMobile) {
    return (
      <>
        {trigger}
        <PackageTemplateMobileModal
          isOpen={isOpen}
          title={title}
          onClose={onClose}
        >
          {renderContent({ mobile: true })}
        </PackageTemplateMobileModal>
      </>
    );
  }

  return (
    <Popover
      isOpen={isOpen}
      positions={['bottom']}
      align='start'
      padding={4}
      onClickOutside={onClose}
      containerStyle={{ zIndex: String(PACKAGE_TEMPLATE_POPOVER_Z_INDEX) }}
      content={({ childRect }) =>
        renderContent({ mobile: false, width: childRect.width })
      }
    >
      {trigger}
    </Popover>
  );
};

export default PackageTemplateResponsiveDropdown;
